/**
 * Action type to signal the closing of the participants pane.
 */
export const PARTICIPANTS_PANE_CLOSE = 'PARTICIPANTS_PANE_CLOSE';

/**
 * Action type to signal the opening of the participants pane.
 */
export const PARTICIPANTS_PANE_OPEN = 'PARTICIPANTS_PANE_OPEN';

/**
* Open Participants Pane Modal.
*/
export const OPEN_PARTICIPANTS_PANE_MODAL = 'OPEN_PARTICIPANTS_PANE_MODAL';

/**
* Close Participants Pane Modal.
*/
export const CLOSE_PARTICIPANTS_PANE_MODAL = 'CLOSE_PARTICIPANTS_PANE_MODAL';

/**
* Close Participants Pane Modal.
*/
export const PARTICIPANTS_PANE_MODAL_ID = 'participantsPaneModalView';
